@if (federalTaxesForm) {
  <form [formGroup]="federalTaxesForm" autocomplete="off">
    <div class="content-container form-comp mb-3">
      <div class="title" [ngClass]="lastUpdatedOn? 'd-flex justify-content-between' : ''">
        <mwp-text-translate text="{{title}}" jsonKey="federalTaxW4" />
        @if (lastUpdatedOn) {
          <div>
            <mwp-text-translate text="Last Updated" jsonKey="lastUpdated" />: {{lastUpdatedOn}}
          </div>
        }
      </div>
      <div class="row content mx-0">
        @if (isDenied) {
          <div class="col-12 mb-3">
            <div class="message-container blue-fill">
              <mwp-text-translate text="Denied Reason" jsonKey="deniedReason" />: {{deniedReason}}
            </div>
          </div>
        }
        <div class=" col-4 my-3">
          <mwp-datepicker [form]="federalTaxesForm" [minDate]="effectiveMinDate" labelName="Effective On" nameForControl="effectiveOn" [autoTranslate]="true" />
        </div>
        <div class="col-4 my-3">
          <mwp-dropdown [form]="federalTaxesForm" labelName="Filing Status" nameForControl="filingStatus" [isListItemArray]="true" [data]="federalFilingStatus" />
          <mat-hint>
            <mwp-text-translate text="*(Step 1c)" jsonKey="*Step1c" />
          </mat-hint>
        </div>
        <div class="col-4 my-3">
          <div>
            <mat-checkbox formControlName="isTwoJobs">
              <mwp-text-translate text="Only Two Jobs" jsonKey="onlyTwoJobs" />
            </mat-checkbox>
          </div>
          <div>
            <mat-hint>
              <mwp-text-translate text="*(Step 2c checked)" jsonKey="step2cChecked" />
            </mat-hint>
          </div>
        </div>
        <div class="col-4 my-3">
          <div>
            <mat-checkbox formControlName="isFedTaxExempt">
              <mwp-text-translate text="Claim Tax Exempt?" jsonKey="claimTaxExempt" />
            </mat-checkbox> 
          </div>
          <div>
            <mat-hint>
              <mwp-text-translate text="*(Employee writes 'Exempt' below line 4c of Step 4)" jsonKey="employeeWritesExemptBelowLine4cOfStep4" />
            </mat-hint>
          </div>
        </div>
        <div class="col-4 my-3">
          <mwp-input [form]="federalTaxesForm" labelName="Claim Dependents" nameForControl="claimDependents" [maskType]="maskType.currency"/>
          <mat-hint>
            <mwp-text-translate text="*(Line 3 of Step 3)" jsonKey="line3ofStep3" />
          </mat-hint>
        </div>
        <div class="col-4 my-3">
          <mwp-input [form]="federalTaxesForm" labelName="Other Income" nameForControl="otherIncome" [maskType]="maskType.currency" />
          <mat-hint>
            <mwp-text-translate text="*(Line 4a of Step 4)" jsonKey="line4aofStep4" />
          </mat-hint>
        </div>
        <div class="col-4 my-3">
          <mwp-input [form]="federalTaxesForm" labelName="Deductions" nameForControl="deductions" [maskType]="maskType.currency"/>
          <mat-hint>
            <mwp-text-translate text="*(Line 4b of Step 4)" jsonKey="line4bofStep4" />
          </mat-hint>
        </div>
        <div class="col-4 my-3">
          <mwp-input [form]="federalTaxesForm" labelName="Extra Withholding" nameForControl="extraWithholding" [maskType]="maskType.currency" />
          <mat-hint>
            <mwp-text-translate text="*(Line 4c of Step 4)" jsonKey="line4cOfStep4" />
          </mat-hint>
        </div>
      </div>
    </div>
  </form>
}
@if (isEditing) {
  <div class="d-flex justify-content-end">
    <button class="mwp-button-secondary" (click)="cancel()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
    <button class="mwp-button-save ms-3" [disabled]="!federalTaxesForm.valid" (click)="save()">
      <mwp-text-translate text="Submit Change Request" jsonKey="submitChangeRequest" />
    </button>
  </div>
}